"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var InputBox_1 = require("../helpers/InputBox");
var ArrowIcon_1 = require("../../ArrowIcon");
var helpers_1 = require("../../helpers");
var keyCode_1 = require("../../helpers/keyCode");
var helpers_2 = require("./helpers");
var Tag_1 = require("./Tag");
var InputControl_1 = require("../helpers/InputControl");
var public_1 = require("../../common/public");
var Root = styled_components_1.default(InputBox_1.InputBox)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    min-width: ", ";\n"], ["\n    min-width: ", ";\n"])), helpers_2.MIN_WIDTH_TAG_INPUT);
var Inner = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    & > * {\n        margin-left: ", "!important;\n        margin-top: ", "!important;\n    }\n    padding-bottom: ", ";\n    margin-top: -", ";\n    padding-right: ", ";\n"], ["\n    display: flex;\n    box-sizing: border-box;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-wrap: wrap;\n    & > * {\n        margin-left: ", "!important;\n        margin-top: ", "!important;\n    }\n    padding-bottom: ", ";\n    margin-top: -", ";\n    padding-right: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.spacing.s;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.spacing.xs;
}, function (_a) {
    var theme = _a.theme;
    return theme === null || theme === void 0 ? void 0 : theme.spacing.s;
});
exports.TagInputControl = helpers_1.createUIElement('TagInputControl', function (_a, ref) {
    var className = _a.className, placeholder = _a.placeholder, tags = _a.value, searchTerm = _a.searchTerm, size = _a.size, maxNumberOfLines = _a.maxNumberOfLines, opened = _a.opened, error = _a.error, disabled = _a.disabled, focused = _a.focused, active = _a.active, canAdd = _a.canAdd, _b = _a.hasSuggest, hasSuggest = _b === void 0 ? true : _b, data = _a.data, onRequestOpen = _a.onRequestOpen, onRequestClose = _a.onRequestClose, onExternalChangeHandler = _a.onChange, onSearch = _a.onSearch, inputError = _a.inputError, validateNewTag = _a.validateNewTag, hasEnterKeyStopPropagation = _a.hasEnterKeyStopPropagation, _c = _a.hasBlurEnter, hasBlurEnter = _c === void 0 ? false : _c, onFocus = _a.onFocus, onBlurHandler = _a.onBlur, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "placeholder", "value", "searchTerm", "size", "maxNumberOfLines", "opened", "error", "disabled", "focused", "active", "canAdd", "hasSuggest", "data", "onRequestOpen", "onRequestClose", "onChange", "onSearch", "inputError", "validateNewTag", "hasEnterKeyStopPropagation", "hasBlurEnter", "onFocus", "onBlur", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var valueState = helpers_1.useStateValue(tags, [tags]);
    var searchTermState = helpers_1.useStateValue(searchTerm || '', [searchTerm], {
        onChange: function (value) {
            onSearch === null || onSearch === void 0 ? void 0 : onSearch(value || '');
            onRequestOpen === null || onRequestOpen === void 0 ? void 0 : onRequestOpen();
        }
    });
    var inputRef = react_1.useRef(null);
    var scrollableRef = react_1.useRef(null);
    var hasControl = canAdd || hasSuggest;
    var canApplySearchTerm = searchTermState.getValue() && (canAdd || (data === null || data === void 0 ? void 0 : data.includes(searchTermState.getValue())));
    function rootFocusHandler() {
        if (hasControl && inputRef && inputRef.current) {
            inputRef.current.focus();
        }
        onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    }
    function onInternalChangeHandler(nextValue) {
        onExternalChangeHandler === null || onExternalChangeHandler === void 0 ? void 0 : onExternalChangeHandler(nextValue);
        setTimeout(function () {
            // We need scroll to after external state provide new value
            if (scrollableRef.current) {
                scrollableRef.current.scrollTop = scrollableRef.current.scrollHeight;
            }
        }, 50);
    }
    function rootBlurHandler() {
        if (!hasControl) {
            onBlurHandler === null || onBlurHandler === void 0 ? void 0 : onBlurHandler();
        }
    }
    function controlChangeHandler(event) {
        searchTermState.setValue(event.target.value || '');
    }
    var validateAndChangeValue = function () {
        var _a;
        var value = searchTermState.getValue();
        var isValueValid = (_a = validateNewTag === null || validateNewTag === void 0 ? void 0 : validateNewTag(searchTermState.getValue())) !== null && _a !== void 0 ? _a : true;
        if (!isValueValid) {
            return;
        }
        searchTermState.setValue('');
        onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler(__spreadArrays(valueState.getValue(), [value]));
        return;
    };
    var keyEnterPressHandler = function (e) {
        if (e.keyCode === keyCode_1.KeyCode.Enter && canApplySearchTerm) {
            validateAndChangeValue();
        }
    };
    function keyDownHandler(e) {
        if (e.keyCode === keyCode_1.KeyCode.Backspace &&
            valueState.getValue().length &&
            !searchTermState.getValue()) {
            e.stopPropagation();
            onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler(valueState.getValue().slice(0, valueState.getValue().length - 1));
            return;
        }
    }
    function controlBlurHandler(e) {
        if (hasBlurEnter && canApplySearchTerm) {
            validateAndChangeValue();
        }
        onBlurHandler === null || onBlurHandler === void 0 ? void 0 : onBlurHandler();
    }
    return (react_1.default.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-TagInputControl " + className, scrollableRef: scrollableRef, size: size, isDisabled: disabled, hasError: error, partialError: inputError, hasSpacing: false, maxRows: maxNumberOfLines, isFocused: focused, isActive: opened || active, onFocus: rootFocusHandler, onBlur: rootBlurHandler, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, actions: hasSuggest
            ? [
                {
                    icon: react_1.default.createElement(ArrowIcon_1.ArrowIcon, { direction: public_1.ARROW_DIRECTION.down }),
                    active: opened,
                    onClick: function () {
                        opened ? onRequestClose === null || onRequestClose === void 0 ? void 0 : onRequestClose() : onRequestOpen === null || onRequestOpen === void 0 ? void 0 : onRequestOpen();
                    }
                }
            ]
            : undefined, "data-focused": focused, ref: ref, style: style }),
        react_1.default.createElement(Inner, null,
            valueState.getValue().map(function (tag, idx) { return (react_1.default.createElement(Tag_1.Tag, { key: tag + ":" + idx, title: tag, disabled: disabled, error: error && !inputError, onRemove: function () {
                    if (!disabled) {
                        onInternalChangeHandler === null || onInternalChangeHandler === void 0 ? void 0 : onInternalChangeHandler(valueState.getValue().filter(function (i) { return i !== tag; }));
                    }
                } })); }),
            hasControl && (react_1.default.createElement(InputControl_1.InputControl, { ref: inputRef, key: "input-control", placeholder: valueState.getValue().length === 0 && hasControl
                    ? placeholder
                    : undefined, onChange: controlChangeHandler, value: searchTermState.getValue(), hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, onKeyEnterPress: keyEnterPressHandler, onKeyDown: keyDownHandler, onBlur: controlBlurHandler, error: error && inputError, width: searchTermState.getValue()
                    ? Math.max(searchTermState.getValue().length + 2, 6) + "ch"
                    : undefined, height: "22px", disabled: disabled })))));
});
var templateObject_1, templateObject_2;
//# sourceMappingURL=TagInputControl.js.map